export const CHAIN_ID = '0x38';

export const CHAIN_NAME = 'BSC';

export const CHAIN_PARAMS = [
  {
    chainId: CHAIN_ID,
    chainName: 'Binance Smart Chain',
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    blockExplorerUrls: ['https://bscscan.com/'],
  },
];

/**
 * Идентификатор сети приходит из разных мест в разном виде: кошелёк отдаёт
 * hex-строку (регистр не гарантирован), ethers — `bigint`. Сравнивать их
 * напрямую нельзя — `56 !== '0x38'`, и проверка сети молча становится
 * бесполезной.
 */
export const normalizeChainId = (chainId) => {
  if (chainId === null || chainId === undefined) return null;

  if (typeof chainId === 'string' && chainId.startsWith('0x')) {
    return chainId.toLowerCase();
  }

  // ethers отдаёт chainId как bigint; Number безопасен — идентификаторы сетей
  // на порядки меньше предела точности.
  return `0x${Number(chainId).toString(16)}`;
};

export const shortAddress = (address) => {
  return address ? `${address.slice(0, 6)}...${address.slice(-5)}` : '';
};
